module.exports = __webpack_public_path__ + "img/tory_the_sky_guardian.c819746e.png";